import apiClient, { plainApiClient } from "..";

export const getFamilyView = ({ user_id, advisor, signal }) => {
  return apiClient.get(
    `GetFamilyViewPortfolio?client_id=${user_id}&advisor=${advisor}`,
    { signal },
  );
};

export const getReturnsLine = ({ isFamily, id, signal }) => {
  return apiClient.get(`${isFamily}/${id}/portfolio/returnstimeline`, {
    signal,
  });
};

export const getQuickViews = ({ id, isFamily, advisor, signal }) => {
  const url = `${isFamily}/${id}/portfolio/quickviews?advisor=${advisor}`;
  return apiClient.get(url, {
    signal,
  });
};

export const liaisonDetails = ({ user_id, loId }) => {
  return apiClient.get(
    `clients/${user_id}/laisonofficers/${loId}/profiledetails`,
  );
};

export const getLinkedClients = () => {
  return apiClient.get("/clients");
};

export const getClientPortfolio = (id, advisor, signal) => {
  return apiClient.get(`/clients/${id}/portfolio?advisor=${advisor}`, {
    signal,
  });
};

export const vehicleDetails = ({
  isFamily,
  id,
  assetClassId,
  vehicleId,
  params,
}) => {
  const url = `${isFamily}/${id}/portfolio/assetclasses/${assetClassId}/instrumentvehicles/${vehicleId}/instruments/returns`;
  return apiClient.get(
    url,
    {
      params,
    },
    { signal: params.signal },
  );
};

export const getInfinityData = ({ isFamily, id, advisor, signal }) => {
  return apiClient.get(`${isFamily}/${id}/InfinityData?advisor=${advisor}`, {
    signal,
  });
};

export const quickView = ({ isFamily, id, instrumentId, advisor, signal }) => {
  const url = `${isFamily}/${id}/portfolio/instrumenttypes/${instrumentId}/instruments?advisor=${advisor}`;
  return apiClient.get(url, { signal });
};

export const usersTransaction = ({ isFamily, id, instrumentId, params }) => {
  const url = `${isFamily}/${id}/portfolio/instruments/${instrumentId}/transactions`;
  return apiClient.get(url, { params });
};

export const getUserTaxLots = ({ isFamily, id, instrumentId, params }) => {
  const url = `${isFamily}/${id}/portfolio/instruments/${instrumentId}/taxlots`;
  return apiClient.get(url, { params });
};

export const getClientPortfolioReturn = (id, advisor, isInfinity, signal) => {
  return apiClient.get(
    `/clients/${id}/portfolio/returns?advisor=${advisor}&isInfinity=${isInfinity}`,
    { signal },
  );
};

export const getClientRecentTransaction = (id, advisor) => {
  return apiClient.get(`/clients/${id}/recenttransactions?advisor=${advisor}`);
};

export const getClientCorporateActions = (id, advisor) => {
  return apiClient.get(`/clients/${id}/corporateactions?advisor=${advisor}`);
};

// to get isInfinity
export const getFamilyPortfolio = (id, advisor, signal) => {
  return apiClient.get(`/families/${id}/portfolio?advisor=${advisor}`, {
    signal,
  });
};

export const getFamilyPortfolioReturn = (id, advisor, isInfinity, signal) => {
  return apiClient.get(
    `/families/${id}/portfolio/returns?advisor=${advisor}&isInfinity=${isInfinity}`,
    { signal },
  );
};

export const infinityReturns = ({ id, advisor, isFamily, signal }) => {
  return apiClient.get(`${isFamily}/${id}/InfinityData?advisor=${advisor}`, {
    signal,
  });
};

export const getFamilyPortfolioReturnInfinity = (
  id,
  advisor,
  isInfinity,
  measureId,
  signal,
) => {
  return apiClient.get(
    `/families/${id}/portfolio/returns?advisor=${advisor}&isInfinity=${isInfinity}&MeasureInstrumentId=${measureId}`,
    { signal },
  );
};

export const getClientPortfolioReturnInfinity = (
  id,
  advisor,
  isInfinity,
  measureId,
  signal,
) => {
  return apiClient.get(
    `/clients/${id}/portfolio/returns?advisor=${advisor}&isInfinity=${isInfinity}&MeasureInstrumentId=${measureId}`,
    { signal },
  );
};

export const getFamilyRecentTransaction = (id, advisor) => {
  return apiClient.get(`/families/${id}/recenttransactions?advisor=${advisor}`);
};

export const getFamilyCorporateActions = (id, advisor) => {
  return apiClient.get(`/families/${id}/corporateactions?advisor=${advisor}`);
};

export const getFamiliesPortfolioAssetClasses = (
  id,
  advisor,
  { signal, isLive, isInfinity, ...params },
) => {
  return apiClient.get(
    `/families/${id}/portfolio/assetclasses/returns?advisor=${advisor}&isInfinity=${isInfinity}&isLive=${isLive}&${
      params?.mesurementId ? `MeasureInstrumentId=${params.mesurementId}` : ""
    }`,
    { signal },
  );
};

export const getClientPortfolioAssetClass = (
  id,
  advisor,
  { isLive, isInfinity, signal, ...params },
) => {
  return apiClient.get(
    `/clients/${id}/portfolio/assetclasses/returns?advisor=${advisor}&isInfinity=${isInfinity}&isLive=${isLive}&${
      params?.mesurementId ? `MeasureInstrumentId=${params.mesurementId}` : ""
    }`,
    { signal },
  );
};

export const getFamiliesPortfolioAssetClassesForFilter = (
  id,
  advisor,
  isLive,
  isInfinity,
  vehicleId,
  assetClassId,
) => {
  return apiClient.get(
    `/families/${id}/portfolio/assetclasses/returns?advisor=${advisor}&AssetClassId=${assetClassId}&VehicleId=${vehicleId}&isInfinity=${isInfinity}&isLive=${isLive}`,
  );
};

export const getClientPortfolioAssetClassForFilter = (
  id,
  advisor,
  isLive,
  isInfinity,
  vehicleId,
  assetClassId,
) => {
  return apiClient.get(
    `/clients/${id}/portfolio/assetclasses/returns?advisor=${advisor}&AssetClassId=${assetClassId}&VehicleId=${vehicleId}&isInfinity=${isInfinity}&isLive=${isLive}`,
  );
};

export const getClientPortfolioQuickviews = (id, advisor) => {
  return apiClient.get(
    `/clients/${id}/portfolio/quickviews?advisor=${advisor}`,
  );
};

export const getFamiliesPortfolioQuickviews = (id, advisor) => {
  return apiClient.get(
    `/families/${id}/portfolio/quickviews?advisor=${advisor}`,
  );
};

export const pointOfConnect = (id, advisor) => {
  return apiClient.get(`/clients/${id}/pointOfContacts`);
};

export const getSecondaryRm = (id) => {
  return apiClient.get(`/clients/${id}/GetSecondaryRMDetails`);
};

export const postFeedback = ({
  id,
  rating,
  UserType,
  feedback,
  username,
  advisor,
}) => {
  const formData = new FormData();
  formData.append("rating", rating);
  formData.append("feedbackDescription", feedback);
  formData.append("UserType", UserType);
  formData.append("Username", username);
  return plainApiClient({
    method: "post",
    url: `/clients/${id}/Feedback`,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      isform: true,
    },
  });
};

export const getNavigationData = ({ type, id }) => {
  return apiClient.get(`/GetPerformanceSnippet?${type}=${id}`);
};

export const getAnalyticsNavigationData = ({ type, id }) => {
  return apiClient.get(`/GetAnalyticsSnippet?${type}=${id}`);
};

export const getUsersPortfolioReturn = ({ apiPreFix, signal, ...params }) => {
  return apiClient.get(`/${apiPreFix}/portfolio/returns`, { params, signal });
};

export const getUsersPortfolio = ({ apiPreFix, signal, ...params }) => {
  return apiClient.get(`/${apiPreFix}/portfolio`, { params, signal });
};

export const getUsersPortfolioAssetClasses = ({
  apiPreFix,
  signal,
  ...params
}) => {
  return apiClient.get(`/${apiPreFix}/portfolio/assetclasses/returns`, {
    params,
    signal,
  });
};

export const getUsersSubAssetClasses = ({ apiPreFix, signal, ...params }) => {
  return apiClient.get(`/${apiPreFix}/portfolioassetclasses`, {
    params,
    signal,
  });
};

export const getUsersReturnsLine = ({ apiPreFix, signal, ...params }) => {
  return apiClient.get(`/${apiPreFix}/portfolio/returnstimeline`, {
    params,
    signal,
  });
};

export const getUsersFamilyView = ({ signal, ...params }) => {
  return apiClient.get(`GetFamilyViewPortfolio`, { params, signal });
};

export const getUsersCurrency = ({ params, signal }) => {
  return apiClient.get("GetCurrency", { params, signal });
};

export const getPortfolioReturn = ({ apiPreFix, signal, ...params }) => {
  return apiClient.get(`/${apiPreFix}/portfolio/returns`, { params, signal });
};

export const getPortfolio = ({ apiPreFix, signal, ...params }) => {
  return apiClient.get(`/${apiPreFix}/portfolio`, { params, signal });
};

export const getUsersRealEstateData = ({ apiPreFix, signal }) => {
  return apiClient.get(`/${apiPreFix}/portfolio/realestates`, {
    signal,
  });
};

export const getUsersDerivativesData = ({ apiPreFix, signal, ...params }) => {
  return apiClient.get(`${apiPreFix}/portfolio/derivatives`, {
    params,
    signal,
  });
};

export const getUsersPortfolioDerivativesData = ({
  apiPreFix,
  item,
  signal,
  ...params
}) => {
  return apiClient.get(
    `${apiPreFix}/portfolio/derivatives/${item.type}/instruments`,
    { params, signal },
  );
};

export const getUsersLiabilitieslas = ({ apiPreFix, signal, ...params }) => {
  return apiClient.get(`${apiPreFix}/portfolio/liabilities/las`, {
    params,
    signal,
  });
};

export const getUsersLiabilities = ({ apiPreFix, signal, ...params }) => {
  return apiClient.get(`${apiPreFix}/portfolio/liabilities`, {
    params,
    signal,
  });
};

export const getUsersInstrumentReturns = ({
  apiPreFix,
  assetClassId,
  vehicleId,
  signal,
  ...params
}) => {
  return apiClient.get(
    `${apiPreFix}/portfolio/assetclasses/${assetClassId}/instrumentvehicles/${vehicleId}/instruments/returns`,
    {
      params,
      signal,
    },
  );
};

export const getUsersTransactions = ({
  apiPreFix,
  instrumentId,
  signal,
  ...params
}) => {
  return apiClient.get(
    `${apiPreFix}/portfolio/instruments/${instrumentId}/transactions`,
    {
      params,
      signal,
    },
  );
};

export const getUsersInvestmentDetailsOffshore = ({
  apiPreFix,
  signal,
  ...params
}) => {
  return apiClient.get(`GetInvestmentDetails`, {
    params,
    signal,
  });
};
